module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "skin clearfix"
  }, [_c('Buttons', {
    staticClass: "chooseSkin",
    attrs: {
      "title": "点击展示",
      "text": "皮肤"
    },
    on: {
      "click": function($event) {
        _vm.changeShowSkin(!_vm.isShowSkin)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "skin-show"
    }
  }, [_c('ol', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSkin == true),
      expression: "isShowSkin==true"
    }],
    staticClass: "clearfix"
  }, _vm._l((_vm.skinColors), function(color, key) {
    return _c('li', {
      key: key,
      on: {
        "click": function($event) {
          _vm.bounce($event)
        }
      }
    }, [_c('Buttons', {
      ref: "color",
      refInFor: true,
      staticClass: "color",
      style: ({
        background: color
      }),
      on: {
        "click": function($event) {
          _vm.changeSkinColor(color)
        }
      }
    })], 1)
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-187b3b64"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/skinColor/skinColor.vue
// module id = 327
// module chunks = 4